import styles from '../InternalExternalDetail.module.css'
import Icon from './Icon'

const ProfileMetaList = ({ items }) => (
  <div className={styles.metaList}>
    {items.map((item) => (
      <div key={item.label} className={styles.metaRow}>
        <span className={styles.metaIcon}>
         {typeof item.icon === 'string' ? <Icon name={item.icon} /> : item.icon}
        </span>
        <span className={styles.metaLabel}>{item.label}</span>
        <span className={styles.metaValue}>{item.value}</span>
      </div>
    ))}
  </div>
)

export default ProfileMetaList
